import { ChangeEvent, useCallback } from 'react'
import _ from 'lodash'
import L1ErrorBlock from '../l1/L1ErrorBlock'
import L3DocumentCamera from '../l3/L3DocumentCamera'
import { ConceptValueDataType } from '@fusion-advantage/backcompat'
import { isConceptStatus } from '@fusion-advantage/formlib'
import { useConceptStatus } from '../../../redux/selectConceptStatus2'
import { useConceptValidator } from './useConceptValidator'
import { useFileUploader } from '../../../lib/useFileUploader'

interface L4DocumentCameraProps {
	cid?: string,
}

const L4DocumentCamera = ({cid}: L4DocumentCameraProps) => {
	const { errorNode } = useConceptValidator({
		tagName: 'L4DocumentCamera',
		cid,
		requireConcept: true,
		allowDataTypes: [ConceptValueDataType.File],
	})
	const conceptStatus = useConceptStatus(cid)

	const { loading, upload, drop } = useFileUploader()
  	const handleFileChange = useCallback(async (e: ChangeEvent<HTMLInputElement>) =>{
    	if (!e.target.files || !e.target.files[0]) {
			return
		}
		const file = e.target.files[0]
		await upload(cid!, file)
		// Remove the file from the value, so when the user picks the same photo
		// after, the value is different
		e.target.value = ''
	}, [upload, cid])
	const handleDelete = useCallback(() => {
		drop(cid!)
	}, [drop, cid])

	if(errorNode) {
		return errorNode
	}
	if(conceptStatus && !isConceptStatus(conceptStatus)) {
		// probably passed SuperconceptStatus instead of ConceptStatus
		// which doesn't make sense for this control
		return <L1ErrorBlock content={`[L4DocumentCamera ${cid}] conceptStatus is incorrect type`} />
	}
	return (
		<L3DocumentCamera
			conceptStatus={conceptStatus}
			onFileChange={handleFileChange} 
			onDelete={handleDelete}
			loading={loading}
		/>
	)
}

export default L4DocumentCamera
